<template>
  <div>
    <div v-show="loading" class="center-block loading-indicator"></div>
    <marker-details v-if="marker" :marker="marker"></marker-details>
    <marker-messages v-if="marker" :marker-id="marker.id"></marker-messages>
    <marker-records v-if="marker" :marker="marker"></marker-records>
  </div>
</template>

<script>
// marker details page master component
// fetches the marker data and loads sub-components to display the marker details

import MarkerRepository from '../repositories/MarkerRepository.js'
import MarkerDetails from './marker/MarkerDetails.vue'
import MarkerRecords from './marker/MarkerRecords.vue'
import MarkerMessages from './marker/MarkerMessages.vue'
import events from '../services/events'

export default {
  components: {
    MarkerDetails,
    MarkerRecords,
    MarkerMessages
  },
  data: function () {
    return {
      marker: '',
      loading: ''
    }
  },
  mounted: function () {
    this.fetchMarkerData()
  },
  methods: {
    fetchMarkerData () {
      var markerId = this.$route.params.markerId
      this.loading = true
      MarkerRepository.fetchMarkerDetails(markerId).then((marker) => {
        this.marker = marker
        this.loading = false
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
    }
  }
}
</script>
